import {h, Fragment} from "preact"
let sale = window.theme?.productBadges?.sale
let collab = window.theme?.productBadges?.collab
let favorite = window.theme?.productBadges?.favorite
let newBadge = window.theme?.productBadges?.new
let online_exclusive = window.theme?.productBadges?.online_exclusive

export const SaleBadge = () => {
    return (
        <div class="ns-badge-sale" dangerouslySetInnerHTML={{__html: sale}}></div>
    )
}

export const OnlineExclusiveBadge = () => {
    return (
        <div class="ns-badge-online" dangerouslySetInnerHTML={{__html: online_exclusive}}></div>
    )
}

export const NewBadge = () => {
    return (
        <div class="ns-badge-new" dangerouslySetInnerHTML={{__html: newBadge}}></div>
    )
}

export const CollaborationBadge = () => {
    return (
        <div class="ns-badge-collab" dangerouslySetInnerHTML={{__html: collab}}></div>
    )
}

export const FavoriteBadge = () => {
    return (
        <div class="ns-badge-favorite" dangerouslySetInnerHTML={{__html: favorite}}></div>
    )
}